/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import Backdrop from "@mui/material/Backdrop";
import { connect } from "react-redux";

const Loader = ({ loading, tenantData }) => {
  if (!loading) return null; // nothing to render when not loading

  const loaderColor = tenantData?.color || "#70b2e8";
  const anyDialogOpen = !!document.querySelector('[role="dialog"]');

  return (
    <Backdrop
      open={true}
      sx={{
        color: "#fff",
        // zIndex: (theme) => theme.zIndex.modal + 1, // above modals
        zIndex: anyDialogOpen ? 1310 : 1280,
        backgroundColor: "rgba(0, 0, 0, 0.3)", // dimmed background
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ScaleLoader
        loading={true}
        height={100}
        width={6}
        radius={3}
        margin="3px"
        color={loaderColor}
      />
    </Backdrop>
  );
};

const mapStateToProps = (state) => ({
  tenantData: state.auth.tenantData,
});

export default connect(mapStateToProps)(Loader);
